import { Component, createRef, PropsWithChildren, ReactNode } from "react";
import { BoundaryContext } from "./Boundary.context";
import { IBoundaryProps } from "./interfaces/IBoundaryProps";
import { IBoundaryContext } from "./interfaces/IBoundaryContext";

export class Boundary extends Component<PropsWithChildren<IBoundaryProps>> {
    private readonly _context: IBoundaryContext<HTMLDivElement> = { element: createRef() };

    public render(): ReactNode {
        return (
            <div ref={this._context.element} className={this.props.className}>
                <BoundaryContext.Provider value={this._context}>{this.props.children}</BoundaryContext.Provider>
            </div>
        );
    }
}
